import PlansInterceptor from '../PlansInterceptor'

const api = new PlansInterceptor()

export default {
  getPlans(): any {
    return api.get('/planos')
  },
}
